import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Transition } from "@headlessui/react";
import { useState } from "react";

type VerificationStatusProps = {
  type: "email" | "phone";
  value: string | null | undefined;
  isVerified: boolean;
};

export default function VerificationStatus({
  type,
  value,
  isVerified,
}: VerificationStatusProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!value) {
    return <div className="text-sm font-bold text-soil">Not added</div>;
  }

  return (
    <div className="flex items-center gap-2 text-sm font-bold text-soil">
      <span className="min-w-0 break-all">{value}</span>
      {isVerified && (
        <div
          className="relative shrink-0"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <CheckCircleIcon
            className="h-5 w-5 text-green-600"
            aria-label={`${type} verified`}
          />
          <Transition
            show={showTooltip}
            enter="transition ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-75"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="absolute left-1/2 z-10 -translate-x-1/2 rounded bg-soil px-2 py-1 text-center text-xs text-white shadow-lg">
              {type === "email" ? "Email" : "Phone"} Verified
            </div>
          </Transition>
        </div>
      )}
    </div>
  );
}
